import { isActionWhitelisted, requiresConfirmation } from 'layout/widgets/adaChat/actionPermissions'
import { LiveFunctionCall } from '../GeminiLiveAPI/lib/multimodal-live-types'

interface UndoRedoArgs {
  direction: 'undo' | 'redo' // Required: specifies whether to undo or redo
  confirmed?: boolean // Required flag to indicate user has confirmed
}

export const TOOL_NAME = 'undo_redo'

const historyCanUndo = () => window.editor?.history && window.editor.history.canUndo()
const historyCanRedo = () => window.editor?.history && window.editor.history.canRedo()

export async function UndoRedoToolCall(functionCall: LiveFunctionCall, history: any, orgId: number | undefined) {
  const args = functionCall.args as UndoRedoArgs

  console.log('[Voice] UndoRedoToolCall', args)

  if (!args.direction || (args.direction !== 'undo' && args.direction !== 'redo')) {
    throw new Error('Direction must be either "undo" or "redo"')
  }

  const isUndo = args.direction === 'undo'

  // Check if the requested operation is available
  if (isUndo && !historyCanUndo()) {
    throw new Error('Undo is not available. There are no actions to undo.')
  }
  if (!isUndo && !historyCanRedo()) {
    throw new Error('Redo is not available. There are no actions to redo.')
  }

  // Check if this action requires confirmation
  const isWhitelisted = isActionWhitelisted('undoRedo')

  if (requiresConfirmation('undoRedo') && !isWhitelisted) {
    // Check if confirmation was explicitly provided in args
    if (!args.confirmed) {
      const actionName = isUndo ? 'undo' : 'redo'
      const errorMessage = `This action requires confirmation. Please ask the user: "Would you like me to ${actionName} the last ${
        isUndo ? 'action' : 'undone action'
      }?" and wait for their confirmation before proceeding.`
      console.error(`[Voice] ${actionName} requires confirmation but confirmed flag not set:`, errorMessage)
      throw new Error(errorMessage)
    }
  }

  // Execute undo or redo
  try {
    if (isUndo) {
      window.editor.undo()
      return {
        success: true,
        message: 'Last action has been undone.',
      }
    } else {
      window.editor.redo()
      return {
        success: true,
        message: 'Last undone action has been redone.',
      }
    }
  } catch (error: any) {
    console.error(`[Voice] Error executing ${isUndo ? 'undo' : 'redo'}:`, error)
    throw new Error(`Failed to ${isUndo ? 'undo' : 'redo'}: ${error.message || 'Unknown error'}`)
  }
}
